export default __webpack_public_path__ + "static/media/arrow-down.8cf25996.svg";